import { render } from "./cartComponent.vue?vue&type=template&id=0b734444"
import script from "./cartComponent.vue?vue&type=script&lang=js"
export * from "./cartComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__